import shrunkCard from "./ShrunkWorkCard.module.css";
import { Link } from "react-router-dom";

function ShrunkWorkCard ({
    img = "",
    h1 = "Title",
    linkTo = ""
}) {
    return (
        <Link to={linkTo} className={shrunkCard.link} data-cursor="true">
            <main id={shrunkCard.card}>
                <div className={shrunkCard.zoom}><img className={shrunkCard.img} src={img} alt={h1} loading="lazy" /></div>
                <h1 className={shrunkCard.h1}>{h1}</h1>
            </main>
        </Link>
    );
}

export default ShrunkWorkCard;